import { InstallLatestCommand } from './commands/install-latest.command';
import { ShellCommand } from './commands/shell.command';
import { WriteFileCommand } from './commands/writeFile.command';
import { WriteRemoteFileCommand } from './commands/writeRemoteFile.command';
import { Procedure } from './procedure.interface';
import { RESET_COMMANDS } from './reset';

export const INSTALL_OPTICIEN: Procedure = {
  name: 'Opticien',
  resetCommands: RESET_COMMANDS,
  commands: [
    new InstallLatestCommand('OPTICIEN', true), // UPDATE
    new InstallLatestCommand('OPTICIEN'),
    new InstallLatestCommand('LENSCAPE', true), // UPDATE
    new InstallLatestCommand('LENSCAPE'),
    new WriteFileCommand('/sdcard/config.txt', 'open_guide:0\n------\nhome_pkg:fr.eyesoft.app\n------\n'),
    new ShellCommand('setprop persist.pxr.force.home fr.eyesoft.app,com.unity3d.player.UnityPlayerNativeActivityPico'),
    new WriteRemoteFileCommand(
      '/storage/self/primary/Android/data/fr.eyesoft.lenscapeapp/files/data/RemoteAssets/test-10h30-avec-coraux-sans-bateau-over-under.mp4',
      '/proxy/s3/fr.eyesoft.recette.lenscape/video/test-10h30-avec-coraux-sans-bateau-over-under.mp4',
    ),
  ],
  validationCommands: [],
};
